import { DateTime } from 'luxon';
import { FC, useRef, useState } from 'react';

import FilterButton from '@/components/FilterDropdown/FilterButton';
import useOnClickOutside from '@/hooks/useOnClickOutside';

import InvoicesFilterBox from './InvoicesFilterBox';

interface Props {
  selectedBanks: string[];
  selectedDepartments: number[];
  selectedCompanies: number[];
  selectedPaymentTypes: string[];
  selectedCreators: number[];
  selectedBankTypes: string[];
  selectedSources: string[];
  selectedBooleanValues: {
    gpm: boolean;
    thousand: boolean;
    missingBank: boolean;
    proforma: boolean;
  };
  setSelectedBanks: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedDepartments: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedCompanies: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedPaymentTypes: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedCreators: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedBankTypes: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedSources: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedBooleanValues: React.Dispatch<
    React.SetStateAction<{
      gpm: boolean;
      thousand: boolean;
      missingBank: boolean;
      proforma: boolean;
    }>
  >;
  paidAtDateRange: { rangeStart?: DateTime; rangeEnd?: DateTime };
  setPaidAtDateRange: React.Dispatch<
    React.SetStateAction<{ rangeStart?: DateTime; rangeEnd?: DateTime }>
  >;
}

const InvoicesFilter: FC<Props> = ({
  selectedBanks,
  selectedDepartments,
  selectedCompanies,
  selectedPaymentTypes,
  selectedCreators,
  selectedBankTypes,
  selectedSources,
  selectedBooleanValues,
  setSelectedBanks,
  setSelectedDepartments,
  setSelectedCompanies,
  setSelectedPaymentTypes,
  setSelectedCreators,
  setSelectedBankTypes,
  setSelectedSources,
  setSelectedBooleanValues,
  paidAtDateRange,
  setPaidAtDateRange,
}) => {
  const [showFilter, setShowFilter] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setShowFilter(false));

  return (
    <div ref={ref}>
      <FilterButton
        onClick={() => {
          setShowFilter(!showFilter);
        }}
        isActive={!!showFilter}
        filterApplied={
          !!selectedBanks.length ||
          !!selectedDepartments.length ||
          !!selectedCompanies.length ||
          !!selectedPaymentTypes.length ||
          !!selectedBankTypes.length ||
          !!selectedCreators.length ||
          !!selectedSources.length ||
          !!paidAtDateRange.rangeStart ||
          selectedBooleanValues.gpm ||
          selectedBooleanValues.thousand ||
          selectedBooleanValues.missingBank ||
          selectedBooleanValues.proforma
        }
      ></FilterButton>
      {showFilter && (
        <InvoicesFilterBox
          selectedBanks={selectedBanks}
          selectedDepartments={selectedDepartments}
          selectedCompanies={selectedCompanies}
          setSelectedBanks={setSelectedBanks}
          setSelectedDepartments={setSelectedDepartments}
          setSelectedCompanies={setSelectedCompanies}
          selectedPaymentTypes={selectedPaymentTypes}
          setSelectedPaymentTypes={setSelectedPaymentTypes}
          selectedCreators={selectedCreators}
          setSelectedCreators={setSelectedCreators}
          selectedBankTypes={selectedBankTypes}
          setSelectedBankTypes={setSelectedBankTypes}
          selectedSources={selectedSources}
          setSelectedSources={setSelectedSources}
          selectedBooleanValues={selectedBooleanValues}
          setSelectedBooleanValues={setSelectedBooleanValues}
          paidAtDateRange={paidAtDateRange}
          setPaidAtDateRange={setPaidAtDateRange}
          closeFilter={() => setShowFilter(false)}
        />
      )}
    </div>
  );
};

export default InvoicesFilter;
